import rootReducer from './reducers';
import { Iterable } from 'immutable';
import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware  from 'redux-saga';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

const logger = createLogger({
  stateTransformer: (state) => {
    const newState = {};

    for (const i of Object.keys(state)) {
      if (Iterable.isIterable(state[i])) {
        newState[i] = state[i].toJS();
      }
      else {
        newState[i] = state[i];
      }
    }
    return newState;
  }
});

const middleware = __DEV__ ? [logger, sagaMiddleware] : [sagaMiddleware];

export default (initialState) => {
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleware)
  );

  sagaMiddleware.run(rootSaga);

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configure-store.js